export const state = {
  stocks: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/stocks/state.js